module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-camel-023-1200x2490.885d4259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-camel-023-1200x2490.jpg
// module id = 1104
// module chunks = 37